import Button from '@/components/Common/Buttons/Button/Button.vue';
import LangFlagGb from '@/components/Common/Icons/LangFlagGb.vue';
import LangFlagBg from '@/components/Common/Icons/LangFlagBg.vue';
import ProfileIcon from '@/components/Common/Icons/ProfileIcon.vue';
import UserTypeMobile from "@/components/Header/HeaderMobile/UserTypeMobile/UserTypeMobile.vue";
import UserNavMobile from "@/components/Header/HeaderMobile/UserNavMobile/UserNavMobile.vue";
import SearchRoommateButtonMobile from "@/components/Header/HeaderMobile/SearchRoommateButtonMobile/SearchRoommateButtonMobile.vue";
import RoomsNavMobile from "@/components/Header/HeaderMobile/RoomsNavMobile/RoomsNavMobile.vue";
import BlogContactsNavMobile from "@/components/Header/HeaderMobile/BlogContactsNavMobile/BlogContactsNavMobile.vue";
import PolicyNavMobile from "@/components/Header/HeaderMobile/PolicyNavMobile/PolicyNavMobile.vue";
import NotificationModal from "@/components/Modal/NotificationModal/NotificationModal.vue";
import LoginModal from "@/components/Modal/LoginModal/LoginModal.vue";
import SignUpModal from "@/components/Modal/SignUpModal/SignUpModal.vue";
import PassChangeModal from "@/components/Modal/PassChangeModal/PassChangeModal.vue";
import RoommateOfferMessageModal from "@/components/Modal/RoommateOfferMessageModal/RoommateOfferMessageModal.vue";
import ForgottenPassModal from "@/components/Modal/ForgottenPassModal/ForgottenPassModal.vue";
import PropertyViewRequestModal from "@/components/Modal/PropertyViewRequestModal/PropertyViewRequestModal.vue";
import CreditBuyModal from "@/components/Modal/CreditBuyModal/CreditBuyModal.vue";
import CoordinatesGuideModal from "@/components/Modal/CoordinatesGuideModal/CoordinatesGuideModal.vue";
import TrustedAgenciesIcon from "@/components/Common/Icons/TrustedAgenciesIcon.vue";
import Logo from "@/components/Header/Logo.vue";
import House from "@/components/Common/Icons/House.vue";
import LogoMobile from "@/components/Common/LogoMobile.vue";
import HeaderSearch from "./HeaderSearch.vue";

const BG_HOSTNAME = import.meta.env.VITE_BG_HOSTNAME;
const EN_HOSTNAME = import.meta.env.VITE_EN_HOSTNAME;
const EN_LANG_CODE = import.meta.env.VITE_EN_LANGUAGE_CODE;
const BG_LANG_CODE = import.meta.env.VITE_BG_LANGUAGE_CODE;

export default {
    name: 'Header',
    components: {
        LogoMobile,
        House,
        Button,
        Logo,
        ProfileIcon,
        LangFlagGb,
        LangFlagBg,
        NotificationModal,
        LoginModal,
        SignUpModal,
        PassChangeModal,
        ForgottenPassModal,
        PropertyViewRequestModal,
        RoommateOfferMessageModal,
        CreditBuyModal,
        UserTypeMobile,
        UserNavMobile,
        SearchRoommateButtonMobile,
        RoomsNavMobile,
        BlogContactsNavMobile,
        PolicyNavMobile,
        CoordinatesGuideModal,
        TrustedAgenciesIcon,
        HeaderSearch: HeaderSearch
    },
    data() {
        return {
            isServiceMenuDropdownOpen: false,
            serviceMenuItems: [

                {
                    title: this.$t('interior'),
                    value: 'interior',
                    routeName: 'InteriorPage',
                },
                {
                    title: this.$t('cleaning-services'),
                    value: 'cleaning',
                    routeName: 'CleaningPage',
                },
                {
                    title: this.$t('moving-services'),
                    value: 'moving',
                    routeName: 'MovingPage',
                }
            ],
            searchType: 'product',
            searchQuery: '',
        }
    },
    computed: {
        user() {
            return this.$store.state.user.info;
        },
        modals() {
            return this.$store.state.utils.modals;
        },
        isUserAuthenticated() {
            return this.$store.state.user.authenticated;
        },
        enLanguageCode() {
            return EN_LANG_CODE;
        },
        bgLanguageCode() {
            return BG_LANG_CODE;
        },
        bgHref() {
            return `https://${BG_HOSTNAME}`;
        },
        enHref() {
            return `https://${EN_HOSTNAME}`;
        }
    },
    watch:{
        async $route (to, from) {
            await this.$store.dispatch('utils/closeModal', 'mobileMenu');
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    },
    methods: {
        async openCart() {
            if (Object.keys(this.$store.state.cart.products).length > 0) {
                this.$router.push({name: 'Cart'});
                return;
            }
            await this.$store.dispatch('utils/openNotificationModal', {
                type: 'error',
                message: 'error-message-empty-cart'
            });
        },
        toggleMobileMenu() {
            this.$store.dispatch('utils/toggleModal', 'mobileMenu');
        },
        openLoginModal() {
            this.$store.dispatch('utils/openModal', 'login');
            this.$store.dispatch('utils/closeModal', 'mobileMenu');
        },
        redirectTo(route, params = {}, query = {}) {
            this.isServiceMenuDropdownOpen = false;
            this.$router.push({'name': route, params: params, query: query})
        },
        onHeaderSearch() {
            const s = (this.searchQuery || '').trim();
            if (!s) {
                return;
            }
            if (this.searchType === 'property') {
                this.redirectTo('PropertySearchPage', {}, { s });
            } else {
                // Default to product search; use 'new' category which exists in app routing usage
                this.redirectTo('MarketplaceCategoryPage', { id: 'new' }, { s });
            }
        },
        changeTranslations(lang = null) {
            if (lang === EN_LANG_CODE) {
                window.location.href = 'https://' + EN_HOSTNAME;
            } else {
                window.location.href = 'https://' + BG_HOSTNAME;
            }
        }
    },
};
